import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, typePrefix } from '~support-at-home/actions/accountCodes';

export interface AccountInvoiceCode {
  id: string;
  company_id: number;
  code: boolean;
  name: string;
  allow_supplier_invoice?: boolean | null;
  allow_supplier_reimburse?: boolean | null;
  [key: string]: any;
}

const initialState: CommonState<AccountInvoiceCode> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  total: 0,
};

const slice = buildSlice<CommonState<AccountInvoiceCode>, AccountInvoiceCode>(typePrefix, initialState, {
  commonConfig: { getAll },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
